import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Star, Zap, TrendingUp, Award } from "lucide-react";

export default function ProductCard({ p, i = 0 }) {
  const cheapest = p.plans?.reduce((a, b) => (a.price < b.price ? a : b), p.plans[0]);
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.5, delay: i * 0.05 }}
    >
      <Link to={`/product/${p.slug}`} data-testid={`product-card-${p.slug}`} className="block kyro-card kyro-hover-lift overflow-hidden group">
        <div className="aspect-[4/3] bg-white/5 relative overflow-hidden">
          {p.image_url && (
            <img
              src={p.image_url}
              alt={p.name}
              className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              loading="lazy"
            />
          )}
          <div className="absolute top-3 left-3 flex flex-wrap gap-1">
            {p.is_featured && (
              <span className="inline-flex items-center gap-1 text-[10px] font-bold uppercase tracking-widest bg-[#FF4433] text-white px-2 py-1 rounded-full">
                <Zap className="w-2.5 h-2.5" /> Featured
              </span>
            )}
            {p.is_trending && (
              <span className="inline-flex items-center gap-1 text-[10px] font-bold uppercase tracking-widest bg-white/10 backdrop-blur text-white px-2 py-1 rounded-full border border-white/10">
                <TrendingUp className="w-2.5 h-2.5" /> Trending
              </span>
            )}
            {p.is_bestseller && (
              <span className="inline-flex items-center gap-1 text-[10px] font-bold uppercase tracking-widest bg-black/60 backdrop-blur text-[#FF4433] px-2 py-1 rounded-full border border-[#FF4433]/40">
                <Award className="w-2.5 h-2.5" /> Best Seller
              </span>
            )}
          </div>
        </div>
        <div className="p-5">
          <div className="flex items-center justify-between mb-2">
            <span className="text-xs text-kyro-faint uppercase tracking-wider">{p.brand || p.category_slug}</span>
            <div className="flex items-center gap-1 text-xs text-kyro-mute">
              <Star className="w-3 h-3 fill-[#FF4433] text-[#FF4433]" />
              {p.rating?.toFixed(1)} <span className="text-kyro-faint">({p.review_count})</span>
            </div>
          </div>
          <h3 className="font-display font-bold text-lg leading-tight mb-1 group-hover:text-[#FF4433] transition-colors">{p.name}</h3>
          <p className="text-sm text-kyro-mute line-clamp-2 mb-4">{p.short_description}</p>
          <div className="flex items-end justify-between">
            <div>
              <p className="text-[11px] text-kyro-faint uppercase tracking-wider">From</p>
              <p className="font-display font-black text-xl">₹{cheapest?.price?.toFixed(0)}</p>
            </div>
            <span className="text-xs text-kyro-mute">1-2 hrs</span>
          </div>
        </div>
      </Link>
    </motion.div>
  );
}
